import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface IUserAccountItem {
  readonly _id: string;
  readonly accountId: string;
  readonly accountName: string;
  readonly slug: string;
  readonly accountImg: string;
}

export interface IUserAccountsSelector {
  readonly id: string;
  readonly type: MESSAGES.USER_ACCOUNTS_SELECTOR;
  readonly rm: boolean;
  readonly nodeId: string;
  readonly pageSize: number;
  readonly items: IUserAccountItem[];
  readonly role?: string;
}

export const createUserAccountsSelector = (data): IUserAccountsSelector => ({
  id: data.id || uuid(),
  type: MESSAGES.USER_ACCOUNTS_SELECTOR,
  rm: Boolean(data.rm),
  nodeId: data.nodeId,
  pageSize: data.pageSize,
  items: data.items,
});
